import Api from '@/api/api';

class SubscriptionPlansApi extends Api {
  constructor() {
    super('subscription-plans');
  }
}

export default new SubscriptionPlansApi();
